<template>
  <div class=""></div>

  <footer class="bg-light site-footer">
    <div class="footer-container">
      <div class="footer-row">
        <div class="footer-col footer-col--brand">
          <router-link to="/" class="footer-logos__item footer-brand" :aria-label="$t('website')">
            <img src="/img/cp/logo_new.svg" alt="" class="footer-brand__img" />
          </router-link>
        </div>
        <div class="footer-col footer-col--partners footer-logos">
          <a href="https://www.bhic.sk" target="_blank" rel="noopener noreferrer" class="footer-logos__item">
            <img src="/img/cp/logo_BHI.png" alt="BHI" />
          </a>
          <a href="https://starr.com/Industries/Travel" target="_blank" rel="noopener noreferrer" class="footer-logos__item">
            <img src="/img/cp/Logo%20new%202026-1.svg" alt="Starr" class="footer-logos__starr" />
          </a>
          <span class="footer-logos__item">
            <img src="/img/cp/ec_logo.png" alt="Eurocross" class="footer-logos__eurocross" />
          </span>
        </div>
        <div class="footer-col footer-col--info">
          <template v-if="isSkLocale">
            <router-link to="/files#info" class="footer-link">{{ $t('footer.all_info') }}</router-link>
            <router-link to="/files#reporting" class="footer-link">{{ $t('footer.docs') }}</router-link>
            <router-link to="/files#law" class="footer-link">{{ $t('footer.required_info') }}</router-link>
            <router-link to="/archive#withdrawal" class="footer-link">{{ $t('footer.withdrawal') }}</router-link>
          </template>
          <router-link v-else to="/files" class="footer-link">
            {{ $t('footer.all_info') }}
          </router-link>
        </div>
      </div>

    </div>
  </footer>
  <!-- cookie warning toast -->
  <div v-if="show" class="cookie-toast-wrap fixed-bottom p-4">
    <div class="toast show bg-light w-40 mw-40" role="alert" data-autohide="false">
      <div class="toast-header">

        <strong class="me-auto"></strong>
        <small></small>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" @click="save(0)"></button>
      </div>
      <div class="toast-body p-4 d-flex flex-column">
        <h4>{{ $t("cookies.title") }}</h4>
        <p>
          {{ $t("cookies.subtitle") }}
        </p>
        <div class="ml-auto">
<!--          <button type="button" class="btn btn-outline-light mr-3" id="btnDeny">-->
<!--            Deny-->
<!--          </button>-->
          <button type="button" class="btn btn-primary" @click="save(1)">
            {{ $t("cookies.button") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import CookieLaw from 'vue-cookie-law'
export default {
  name: "FooterPart",
  components: {

  },
  data: function (){
    return { show: false}
  },
  props: {
    product: String
  },
  computed: {
    isSkLocale() {
      return this.$i18n.locale === 'sk';
    },
  },
  methods: {
    save(val){
      localStorage.setItem('cookies', val);
      this.show = false;
    }
  },
  mounted() {
     this.show = !localStorage.getItem('cookies');
  }
}
</script>

<style scoped>
footer.site-footer{
  border-top: 5px solid var(--main-color);
}
.footer-container{
  width: 100%;
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 12px;
  padding-right: 12px;
}
.footer-row{
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0.5rem 0;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.footer-col--brand{
  flex: 0 0 auto;
}
.footer-col--partners{
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.footer-col--info{
  flex: 0 0 auto;
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.footer-link{
  display: block;
}
.footer-brand__img{
  height: 60px;
  width: auto;
  max-width: min(280px, 40vw);
}
.footer-logos{
  align-items: center;
}
.footer-logos__item{
  display: inline-flex;
  align-items: center;
  margin: 16px 12px;
  line-height: 0;
}
.footer-logos__item img{
  display: block;
  max-height: 60px;
  width: auto;
  mix-blend-mode: darken;
  pointer-events: none;
}
.footer-logos__item img.footer-logos__starr{
  max-height: 50px;
  mix-blend-mode: normal;
}
@media (max-width: 767.98px) {
  .footer-row{
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .footer-col{
    width: 100%;
    align-self: flex-start;
  }
  .footer-col--partners{
    justify-content: flex-start;
    align-items: center;
    align-content: center;
  }
  .footer-col--info{
    text-align: left;
  }
  .footer-logos{
    align-items: center;
  }
  .footer-logos__item{
    margin: 12px 12px 12px 0;
  }
  .footer-logos__item img{
    max-height: 50px;
  }
  .footer-logos__item img.footer-logos__starr{
    max-height: 40px;
  }
}
.footer-logos__eurocross{
  mix-blend-mode: normal;
}
a{
  text-decoration: none;
  color: var(--main-color);
}
</style>
